import React from 'react'
import PropTypes from 'prop-types'
import Items from 'components/Items'
import FormFooter from 'components/FormFooter'
import SectionHeader from 'components/SectionHeader'
import AppFooter from 'components/AppFooter'
import ScreenLoader from 'components/ScreenLoader'
import ItemsCreationForm from 'components/ItemsCreationForm'
import './style.css'


const FormItems = (props) => {
    const onSave = () => {
        props.fetchSaveShoppingList()
    }

    return (
        <div className='content'>
            { props.isLoading &&
                <ScreenLoader isLoading={true} />
            }

            <SectionHeader>
                <ItemsCreationForm />
            </SectionHeader>

            <div className='content-aligner'>
                <Items />
            </div>

            <AppFooter>
                <FormFooter
                    onSave={onSave}
                />
            </AppFooter>
        </div>
    )
}

FormItems.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    fetchSaveShoppingList: PropTypes.func.isRequired,
    theme: PropTypes.string.isRequired
}

export default FormItems
